// Reveal a complete decoded image, never a partially painted download.
// The tiny background and the studio links stay visible if the image fails.
export function revealStudioBackdrop(root) {
  if (!root) return () => {};
  const image = root.querySelector('img');
  let cancelled = false;
  const reveal = async () => {
    if (!image.naturalWidth) return;
    try { if (image.decode) await image.decode(); } catch { return; }
    if (!cancelled) root.classList.add('studio-backdrop-ready');
  };
  image.addEventListener('load', reveal);
  if (image.complete) reveal();
  return () => { cancelled = true; image.removeEventListener('load', reveal); };
}
